import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import { PaginationListStandalone } from "react-bootstrap-table2-paginator";
import { Col, Row, Button } from "reactstrap";
import {
	ExcelBtnClassName,
	ExcelBtnTitle,
	customMatchFunc,
} from "../views/ticketModule/variables/ListingVariables";
import "../views/stylesheets/style.scss";
import { Link } from "react-router-dom";
import { Pager } from "./Pager";
import overlayFactory from "react-bootstrap-table2-overlay";
import { TableLoader } from "./TableLoader";
import ButtonLoader from "./ButtonLoader";

export const Table = (props) => {
	const {
		items,
		columns,
		tableStyle,
		paginationProps,
		paginationTableProps,
		onTablePageChange,
		tableLoader,
		showFeedback,
		SearchBar,
		inputValue,
		exportExcelButton,
		exportToExcelClick,
		defaultSorted,
		myTickets,
		projectList,
		keyField,
		pagerData,
		headerClass,
		bodyClasses,
		adminPagination,
		rowEvents,
		selectRow,
		showBtnLoader,
		disabled,
		striped: propStriped
	} = props;
	const striped = propStriped === false ? false : true;
	//Function to handle Next page
	const handleNextPage = () => {
		if (paginationProps.page === paginationProps.paginationSize) return;
		paginationProps.onPageChange(paginationProps.page + 1);
		if (pagerData) onTablePageChange(paginationProps.page + 1, "right");
		else onTablePageChange(paginationProps.page + 1);
	};

	//Function to handle previous page
	const handlePrevPage = () => {
		if (paginationProps.page === 1) return;
		paginationProps.onPageChange(paginationProps.page - 1);
		if (pagerData) onTablePageChange(paginationProps.page - 1, "left");
		else onTablePageChange(paginationProps.page - 1);
	};

	return (
		<div>
			<ToolkitProvider
				bootstrap4
				keyField={keyField}
				data={items}
				columns={columns}
				search={{ customMatchFunc, searchFormatted: true }}
			>
				{(props) => {
					return (
						<div className="container-fluid p-0 fbList">
							{/*--------- SearchBar and Buttons ---------*/}
							{!showFeedback && (
								<Row className="myticketrow">
									<div className="col-lg-12 col-md-12 col-sm-12 d-flex py-2 searchColumn">
										<div className="col d-flex justify-content-start mt-2 pl-1">
											{exportExcelButton && (
												<ButtonLoader
													className={
														ExcelBtnClassName
													}
													onClick={exportToExcelClick}
													btnTitle={ExcelBtnTitle}
													showBtnLoading={
														showBtnLoader
													}
													disabled={disabled}
												/>
											)}
										</div>
										<SearchBar
											{...props.searchProps}
											className="customSearch"
										></SearchBar>
										{myTickets && (
											<Link to="/Ticket">
												<Button
													variant="info"
													className="addbtn ml-1"
												>
													Add
												</Button>
											</Link>
										)}
										{projectList && (
											<Link to="/CreateProject">
												<Button
													variant="info"
													className="addbtn ml-1"
												>
													Add
												</Button>
											</Link>
										)}
									</div>
								</Row>
							)}

							{/*--------- Table Cpmponent ---------*/}
							{pagerData ? (
								<BootstrapTable
									remote
									onTableChange={onTablePageChange}
									classes="table-sm table-borderless"
									hover
									rowStyle={tableStyle}
									headerClasses={
										headerClass || "header-class"
									}
									bodyClasses={bodyClasses || ""}
									bordered={false}
									{...props.baseProps}
									defaultSorted={defaultSorted}
									defaultSortDirection="asc"
									noDataIndication={
										<TableLoader
											tableLoader={tableLoader}
										/>
									}
									{...paginationTableProps}
									loading={tableLoader || false}
									overlay={overlayFactory({
										spinner: true,
										color: "secondary",
										styles: {
											overlay: (base) => ({
												...base,
												background: "rgba(0,0,0,0.1)",
											}),
										},
									})}
									rowEvents={rowEvents}
									striped={
										columns[columns.length - 1].text === "Action" && striped === true
									}
									condensed
									selectRow={selectRow}
								/>
							) : (
								<BootstrapTable
									selectRow={selectRow}
									classes="table-sm table-borderless"
									hover
									rowStyle={tableStyle}
									headerClasses={
										headerClass || "header-class"
									}
									bordered={false}
									{...props.baseProps}
									defaultSorted={defaultSorted}
									loading={tableLoader || false}
									overlay={overlayFactory({
										spinner: true,
										color: "secondary",
										styles: {
											overlay: (base) => ({
												...base,
												background: "rgba(0,0,0,0.1)",
											}),
										},
									})}
									noDataIndication={
										<TableLoader
											tableLoader={tableLoader}
										/>
									}
									{...paginationTableProps}
								/>
							)}
						</div>
					);
				}}
			</ToolkitProvider>

			{props.flag && (
				<Row className="total-hours-row my-2">
					<Col className="total-hours-col">
						{props.flagTitle
							? `${props.flagTitle} : ${props.flagCount}`
							: `Total Hours : ${props.totalHours}`}
					</Col>
				</Row>
			)}

			{/*--------- Show pagination Component if there is pager data ---------*/}
			{pagerData ? (
				<Pager
					receiveData={(pageNumber, PageSize) => {
						props.receiveData(pageNumber, PageSize);
					}}
					pager={pagerData}
					onPaginateLeft={handlePrevPage}
					onPaginateRight={handleNextPage}
					adminPagination={adminPagination || false}
				/>
			) : paginationProps ? (
				inputValue === "" && (
					<div className="d-flex justify-content-end" role="group">
						<button
							className="btn prevPg btn-sm mr-2"
							disabled={paginationProps.page === 1}
							onClick={handlePrevPage}
						>
							Prev
						</button>
						<button
							className="btn nextPg btn-sm"
							disabled={
								paginationProps.page <=
								paginationProps.paginationSize
							}
							onClick={handleNextPage}
						>
							Next
						</button>
					</div>
				)
			) : null}

			{/*--------- Show page number Component if there is no pager data ---------*/}

			{!pagerData && inputValue !== "" && (
				<PaginationListStandalone {...paginationProps} />
			)}
		</div>
	);
};
